import { useState } from "react";
import { ArrowRight, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export const WAITLIST_LINE = "The Roots Club is launching soon. Join the waitlist to be first to hear — and get an exclusive founding member offer when we open the doors.";

export const WaitlistForm = ({ onDone }) => {
  const [f, setF] = useState({ name: "", email: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/waitlist", f); setDone(true); onDone?.(); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  if (done) return (
    <div className="text-center py-4" data-testid="waitlist-success">
      <CheckCircle2 className="h-10 w-10 text-leaf mx-auto" />
      <p className="font-serif uppercase text-2xl text-navy mt-3">You're on the list.</p>
      <p className="text-sm text-muted-foreground mt-2">Check your inbox for a confirmation. You'll be first to hear when the doors open.</p>
    </div>
  );
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="waitlist-form">
      <Input required placeholder="Your name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="waitlist-name" className="h-12 bg-white" autoComplete="name" />
      <Input required type="email" placeholder="Email address" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="waitlist-email" className="h-12 bg-white" autoComplete="email" />
      <Button type="submit" disabled={busy} data-testid="waitlist-submit" className="w-full h-12 rounded-full bg-pinkb hover:bg-pinkb/90 text-white text-base">
        {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Join the Waitlist
      </Button>
      <p className="text-[11px] text-muted-foreground text-center">We'll only email you about The Roots Club. Unsubscribe any time.</p>
    </form>
  );
};

export const WaitlistButton = ({ className = "", testId = "waitlist-btn", arrow = true, line = false, lineClass = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }} data-testid={testId}
        className={`inline-flex items-center justify-center gap-2 rounded-full bg-pinkb hover:bg-pinkb/90 text-white font-medium transition-colors ${className}`}>
        Join the Waitlist{arrow && <ArrowRight className="h-4 w-4" />}
      </button>
      {line && <p className={`mt-3 text-sm max-w-md ${lineClass}`} data-testid={`${testId}-line`}>{WAITLIST_LINE}</p>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-3xl" data-testid="waitlist-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif uppercase text-2xl text-navy">Join the waitlist</DialogTitle>
            <DialogDescription>{WAITLIST_LINE}</DialogDescription>
          </DialogHeader>
          <WaitlistForm />
        </DialogContent>
      </Dialog>
    </>
  );
};
